import React, { Component } from 'react';
import { Subsection } from './Subsection';
import { Logo } from './Logo';
import { Grid, Column, Row } from "react-awesome-grid";
import MediaQuery from 'react-responsive';

export class OverviewSection extends Component {
    render() {
        return (
            <div className="overview section-background">
                <Subsection imageUrl='OverviewBackground.jpg'>
                    <Grid>
                        <Column width="*">
                            <Row height="auto">
                                <Column width="auto">
                                    <Logo size="100" />
                                </Column>
                                <Column width="*" verticalContentAlignment="center" horizontalContentAlignment="center">
                                    <MediaQuery minWidth={1001}>
                                        <div>
                                            <h1>Alexander Kvenvolden</h1>
                                        </div>
                                    </MediaQuery>
                                    <MediaQuery maxWidth={1000}>
                                        <Row height="*" horizontalContentAlignment="center" verticalContentAlignment="bottom">
                                            <h1>Alexander</h1>
                                        </Row>
                                        <Row height="*" horizontalContentAlignment="center" verticalContentAlignment="top">
                                            <h1>Kvenvolden</h1>
                                        </Row>
                                    </MediaQuery>
                                </Column>
                                <MediaQuery maxWidth={800}>
                                    <Column width="auto" verticalContentAlignment="center">
                                        <img src="Headshot.jpg" alt="Head shot" style={{ width: "100px", marginLeft: "1em" }} />
                                    </Column>
                                </MediaQuery>
                            </Row>
                            <Row height="auto" horizontalContentAlignment="center">
                                <p>
                                    Hi! I'm a senior software engineer with 8+ years of professional experience across a diverse set of platforms and technologies. Here you'll find an interactive resume
                                    of my work showcasing my skills and my experience both professionally as well as my personal projects.
                                </p>
                            </Row>
                            <Row>
                                <strong>
                                    I'm actively looking for a new role, and I'm available for interviews. If you want to get in touch with me, please message me on LinkedIn and I'd be happy to discuss!
                                </strong>
                            </Row>
                            <Row height="auto" horizontalContentAlignment="space-around">
                                <button className="btn experience" onClick={this.experienceClicked.bind(this)} > Experience</button>
                                <button className="btn projects" onClick={this.projectsClicked.bind(this)}>Projects</button>
                                <button className="btn education" onClick={this.educationClicked.bind(this)}>Education</button>
                                <a className="btn linkedin" href="https://linkedin.com/in/kvenvolden">LinkedIn</a>
                            </Row>
                        </Column>
                        <MediaQuery minWidth={801}>
                            <Column width="auto" verticalContentAlignment="center">
                                <img src="Headshot.jpg" alt="Head shot" style={{ width: "200px", marginLeft: "1em" }} />
                            </Column>
                        </MediaQuery>
                    </Grid>
                </Subsection>
            </div>);
    }

    experienceClicked() {
        if (this.props.onExperienceClicked)
            this.props.onExperienceClicked();
    }

    educationClicked() {
        if (this.props.onEducationClicked)
            this.props.onEducationClicked();
    }

    projectsClicked() {
        if (this.props.onProjectsClicked)
            this.props.onProjectsClicked();
    }
}